import Main from "./pages/Main";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import './index.css';
import PrivacyPolicy from "./pages/PrivacyPolicy";
import LegalDisclaimer from "./pages/LegalDisclaimer";


function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Main/>} />
                <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
                <Route path="/legal-disclaimer" element={<LegalDisclaimer/>} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
